<template>
  <!--安装 npm i wangeditor --save -->
  <div>
    <!-- <div @click="add">添加</div> -->
    <div class="editor">
      <div
        ref="editor"
        class="textNeirong"
      />

    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
export default {
  name: 'EditorItem',
  model: {
    prop: 'value', // v-model 接收的值=props的message属性接收的值
    event: 'change' // v-model 发生变化时触发的方法
  },
  props: {
    value: {
      // 富文本数据
      type: String,
      default: ''
    },
    isClear: {
      type: Boolean,
      default: false
    },
    placeholder: {
      // placeholder 提示文字
      type: String,
      default: '请输入...'
    }
  },
  data() {
    return {
      editor: null,
      info_: null,
      blurIndex: null,
      // 配置富文本编辑器的菜单栏
      menu: [
        'undo', // 撤销
        'redo', // 重复
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'indent', // 缩进
        'lineHeight', // 行高
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'todo', // 待办
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        // 'video', // 视频
        'table', // 表格
        'code', // 插入代码
        'splitLine' // 分割线
      ]
    }
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear()
        this.info_ = null
      }
    },
    value: function(value) {
      // 如果值不相等再进行赋值，避免多次赋值造成闪烁
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value)
      }
    }
    // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  created() {},
  mounted() {
    this.seteditor()
    // 使用 editor.txt.html() 获取 html 。
    this.editor.txt.html(this.value)
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    // send(val, type) {
    //   console.log(val, type, '====')
    //   if (type === 1) {
    //     this.editor.cmd.do('insertHTML', `<img data-href="${val.id}" src="${val.path}">`)
    //   }
    //   if (type === 2) {
    //     this.editor.cmd.do('insertHTML', `<a href="${val.link}" target='mini_program_type=text|type=${val.appid}|title=${val.title}|link=${val.link}'>${val.title}</a>`)
    //   }
    //   if (type === 3) {
    //     this.editor.cmd.do('insertHTML', `<img src="${val.imgsrc}" alt="${val.link}" data-href="mini_program_type=img|type=${val.appid}|imgid=${val.imgid}">`)
    //   }
    //   if (type === 4) {
    //     this.editor.cmd.do('insertHTML', `<img src="${val.imgsrc}" alt="${val.link}" data-href="mini_program_type=card|type=${val.appid}|imgid=${val.imgid}|cardtitle=${val.cardinput}">`)
    //   }
    //   if (type === 5) {
    //     // console.log('222', val)
    //     this.editor.txt.clear()
    //     this.editor.cmd.do('insertHTML', `${val}`)
    //   } if (type === 6) {
    //     this.editor.cmd.do('insertHTML', ` <a
    //     href="${val.link}"
    //     target="_blank"
    //     linktype="text"
    //     tab="outerlink"
    //   >
    //   <img data-href="${val.id}" src="${val.path}">
    // </a>`)
    //   }
    //   if (type === 7) {
    //     this.editor.cmd.do('insertHTML', `<img src="${val.qr_code}">`)
    //   }
    // },
    send(val, type) {
      console.log(val, type, '====')
      if (type === 1) {
        this.editor.cmd.do('insertHTML', `<div style="text-align: center; margin: 10px 0;"><img data-href="${val.id}" src="${val.path}" style="max-width: 100%; display: block; margin: 0 auto;"></div>`)
      }
      if (type === 2) {
        this.editor.cmd.do('insertHTML', `<a href="${val.link}" target='mini_program_type=text|type=${val.appid}|title=${val.title}|link=${val.link}'>${val.title}</a>`)
      }
      if (type === 3) {
        this.editor.cmd.do('insertHTML', `<div style="text-align: center; margin: 10px 0;"><img src="${val.imgsrc}" alt="${val.link}" data-href="mini_program_type=img|type=${val.appid}|imgid=${val.imgid}" style="max-width: 100%; display: block; margin: 0 auto;"></div>`)
      }
      if (type === 4) {
        this.editor.cmd.do('insertHTML', `<div style="text-align: center; margin: 10px 0;"><img src="${val.imgsrc}" alt="${val.link}" data-href="mini_program_type=card|type=${val.appid}|imgid=${val.imgid}|cardtitle=${val.cardinput}" style="max-width: 100%; display: block; margin: 0 auto;"></div>`)
      }
      if (type === 5) {
        this.editor.txt.clear()
        this.editor.cmd.do('insertHTML', `${val}`)
      }
      if (type === 6) {
        this.editor.cmd.do(
          'insertHTML',
          `<div style="text-align: center; margin: 10px 0;"><a
        href="${val.link}"
        target="_blank"
        linktype="text"
        tab="outerlink"
      >
        <img data-href="${val.id}" src="${val.path}" style="max-width: 100%; display: block; margin: 0 auto;">
      </a></div>`
        )
      }
      if (type === 7) {
        this.editor.cmd.do('insertHTML', `<div style="text-align: center; margin: 10px 0;"><img src="${val.qr_code}" style="max-width: 100%; display: block; margin: 0 auto;"></div>`)
      }
      if (type === 8) {
        this.editor.cmd.do('insertHTML', `<a href="${val.huokelink}" target="_blank" style="display: block;"><img src="${val.button_img}" style="max-width: 100%; height: auto; display: block;"></a>`)
      }
    },
    seteditor() {
      // 创建编辑器
      this.editor = new E(this.$refs.editor)
      this.editor.config.width = 500
      this.editor.config.height = 600
      this.editor.config.uploadImgShowBase64 = true // 使用 base64 格式保存图片。即，可选择本地图片，编辑器用 base64 格式显示图片。
      this.editor.config.uploadImgMaxSize = 1 * 1024 * 1024 // 将图片大小限制为 1MB
      this.editor.config.uploadImgMaxLength = 1 // 限制一次最多上传 1 张图片
      // 自定义 onchange 触发的延迟时间，默认为 200 ms
      this.editor.config.onchangeTimeout = 1000 // 单位 ms
      this.editor.config.menus = this.menu // 自定义菜单
      this.editor.config.placeholder = this.placeholder // placeholder 提示文字
      this.editor.config.pasteFilterStyle = false
      console.log('this.editor.config', this.editor.config)
      this.editor.config.onchange = html => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
      }
      // 创建富文本编辑器
      this.editor.create()
    },
    add() {
      this.editor.cmd.do('insertHTML', '<img src="https://ziyuan.jingxuansz.com/cashback_qrcodes/20221118174748637754c45a133.png" alt="" style="width: 80px; height: 100px;">')
      // const str = '22222'
      //  this.value = this.value.slice(0, this.blurIndex) + str + this.value.slice(this.blurIndex)
    }
  }
}
</script>

<style lang="less">
.editor {
  width: 100%;
  margin: auto;
  position: relative;
  z-index: 99 !important;
}
</style>
